import React from 'react'

function ToggleBtn({ value, onChange, title }) {


    return (
        <>
            <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">{title}</label>
            <label class="relative inline-flex items-center cursor-pointer">

                <input
                    type="checkbox"
                    checked={value}
                    onChange={(e) => onChange(e.target.checked)}
                    className="sr-only peer"
                />

                <div class="w-11 h-6 bg-gray-200 hover:bg-gray-300 peer-focus:outline-0  rounded-full peer transition-all ease-in-out duration-500 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600 hover:peer-checked:bg-indigo-700 "></div>
            </label>
        </>
    )
}

export default ToggleBtn